export const CosmeticsIcon = () => {
    return (
      <div className="flex items-center justify-center">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          width="48"
          height="48"
          className="text-pink-500"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          {/* Lipstick */}
          <path d="M9 3h6v5H9z" fill="#FF69B4" />
          <path d="M10 8v3h4V8" stroke="#FF69B4" />
          <path d="M9 3h6v5H9z" stroke="#FF1493" />
          
          {/* Perfume bottle */}
          <rect x="14" y="10" width="5" height="7" rx="1" fill="#FFB6C1" stroke="#FF1493" />
          <rect x="15" y="8" width="3" height="2" rx="0.5" fill="#FFB6C1" stroke="#FF1493" />
          <line x1="16.5" y1="10" x2="16.5" y2="17" stroke="#FF1493" strokeDasharray="1,1" />
          
          {/* Powder container */}
          <circle cx="7" cy="14" r="3" fill="#FFB6C1" stroke="#FF1493" />
          <circle cx="7" cy="14" r="2" stroke="#FF1493" strokeDasharray="0.5,0.5" />
          
          {/* Makeup brush */}
          <line x1="11" y1="15" x2="14" y2="18" stroke="#8B4513" strokeWidth="2" />
          <path d="M8 18c0,0 3,-3 6,0" fill="#F5DEB3" stroke="#DEB887" />
          
          {/* Base cirle */}
          <circle cx="12" cy="12" r="10" fill="none" stroke="#FF1493" strokeOpacity="0.2" />
        </svg>
      </div>
    );
  };
